import { Star } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { REVIEWS } from "@/lib/config";

const Stars = () => (
    <div className="flex gap-1" aria-label="5 de 5 estrellas">
        {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-brand-orange text-brand-orange" />
        ))}
    </div>
);

export const Reviews = () => (
    <section
        id="opiniones"
        className="bg-brand-cream py-20 dark:bg-brand-night sm:py-28"
        data-testid="reviews-section"
    >
        <div className="mx-auto max-w-6xl px-5">
            <SectionHeading
                kicker="Opiniones"
                title="Lo que dicen quienes ya la usan"
                sub="Personas que han encontrado su piso o su casa con la app de Puertalia Portal."
            />
            <div className="mt-12 grid gap-6 md:grid-cols-3 md:gap-8">
                {REVIEWS.map((review, i) => (
                    <Reveal key={review.name} delay={i * 0.12}>
                        <figure
                            className="flex h-full flex-col rounded-2xl border border-brand-navy/10 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
                            data-testid={`review-card-${i + 1}`}
                        >
                            <Stars />
                            <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-brand-navy/80 dark:text-white/70">
                                “{review.text}”
                            </blockquote>
                            <figcaption className="mt-6 flex items-center gap-3 border-t border-brand-navy/10 pt-5 dark:border-white/10">
                                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-navy font-sans text-sm font-bold text-white dark:bg-brand-orange">
                                    {review.name.charAt(0)}
                                </span>
                                <span>
                                    <span className="block font-sans text-sm font-bold text-brand-navy dark:text-white">
                                        {review.name}
                                    </span>
                                    <span className="block font-sans text-xs text-brand-navy/50 dark:text-white/50">
                                        {review.city}
                                    </span>
                                </span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
